import { logoGJ, logoHansefit, logoRTL } from 'img/PartnerLogosSlider';

export const businessCooperations = [
  {
    name: 'G+J',
    cooperationLogo: logoGJ,
  },
  {
    name: 'Hansefit',
    cooperationLogo: logoHansefit,
  },
  {
    name: 'RTL',
    cooperationLogo: logoRTL,
  },
];
